import { createIcon } from '../createIcon';

export const FilterAltIconConfig = {
  name: 'FilterAltIcon',
  height: 1024,
  width: 951,
  svgPath: 'M908.571 758.857c-113.714 113.714-434.354 118.857-434.354 118.857-366.903 0-437.646-124.571-437.646-124.571-22.857-34.286-0.114-58.286-0.114-58.286l329.143-330.286v-254.857c0-9.714 4-18.857 10.857-25.714l146.286-146.286c6.857-7.429 16-10.857 25.714-10.857 4.571 0 9.714 1.143 14.286 2.857 13.143 5.714 22.286 18.857 22.286 33.714v401.143l329.166 328.023c0 0-2.4-1.509-5.509-1.12l5.509 1.12c20.526 34.309-5.623 66.263-5.623 66.263zM475.429 656c-181.783 0-336 18.126-336 54.56s154.217 77.417 336 77.417 336-40.983 336-77.417-154.217-54.56-336-54.56z',
  yOffset: 64,
  xOffset: 0,
  transform: 'rotate(180 0 512) scale(-1 1)'
};

export const FilterAltIcon = createIcon(FilterAltIconConfig);

export default FilterAltIcon;